import Footer from "./Footer";
import Header from "./Header";
import { closeModal } from "../../actions/ui";
import { useSelector, useDispatch } from "react-redux";
import Backdrop from "../../components/Backdrop";
import SmallModal from "../../components/SmallModal";

function DefaultLayout(props) {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.ui.smallModal.isModalOpen);
  const modalTitle = useSelector((state) => state.ui.smallModal.title);
  const modalText = useSelector((state) => state.ui.smallModal.text);
  const modalBody = useSelector((state) => state.ui.smallModal.body);
  const modalCancelText = useSelector(
    (state) => state.ui.smallModal.cancelText
  );
  const modalConfirmText = useSelector(
    (state) => state.ui.smallModal.confirmText
  );
  const cancelUIModalHandler = () => {
    dispatch(closeModal());
  };
  const closeUIModalHandler = () => {
    dispatch(closeModal());
  };
  const okUIModalHandler = () => {
    dispatch(closeModal());
  };
  return (
    <div className="site">
      <Header />
      <main className="site-content">
        {props.body}
        {isModalOpen ? (
          <div>
            <SmallModal
              title={modalTitle}
              text={modalText}
              body={modalBody}
              onCancel={cancelUIModalHandler}
              onConfirm={okUIModalHandler}
              onCancelText={modalCancelText}
              onConfirmText={modalConfirmText}
            />
            <Backdrop onCancel={closeUIModalHandler} />
          </div>
        ) : null}
      </main>
      <Footer />
    </div>
  );
}

export default DefaultLayout;
